interface PaginationProps {
  page: number;
  totalPages: number;
  onChange: (page: number) => void;
}

const getPages = (page: number, totalPages: number) => {
  const pages: (number | string)[] = [];
  if (totalPages <= 7) {
    for (let i = 1; i <= totalPages; i += 1) pages.push(i);
    return pages;
  }
  pages.push(1);
  if (page > 3) pages.push('prev-ellipsis');
  const start = Math.max(2, page - 1);
  const end = Math.min(totalPages - 1, page + 1);
  for (let i = start; i <= end; i += 1) pages.push(i);
  if (page < totalPages - 2) pages.push('next-ellipsis');
  pages.push(totalPages);
  return pages;
};

export default function Pagination({ page, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;
  const pages = getPages(page, totalPages);

  return (
    <nav className="flex flex-wrap items-center justify-center gap-2" aria-label="分页导航">
      <button
        type="button"
        onClick={() => onChange(Math.max(1, page - 1))}
        disabled={page === 1}
        className={`flex h-9 cursor-pointer items-center gap-1 rounded-md border px-3 text-sm transition-colors ${
          page === 1
            ? 'cursor-not-allowed border-background-200 text-foreground-300'
            : 'border-background-200 text-foreground-700 hover:border-primary-300 hover:text-primary-700'
        }`}
      >
        <i className="ri-arrow-left-s-line" />
        上一页
      </button>

      {pages.map((item) =>
        typeof item === 'number' ? (
          <button
            key={item}
            type="button"
            onClick={() => onChange(item)}
            className={`h-9 w-9 cursor-pointer rounded-md border text-sm transition-colors ${
              item === page
                ? 'border-primary-500 bg-primary-500 font-semibold text-background-50'
                : 'border-background-200 text-foreground-700 hover:border-primary-300 hover:text-primary-700'
            }`}
            aria-current={item === page ? 'page' : undefined}
          >
            {item}
          </button>
        ) : (
          <span key={item} className="px-1 text-sm text-foreground-400">
            …
          </span>
        ),
      )}

      <button
        type="button"
        onClick={() => onChange(Math.min(totalPages, page + 1))}
        disabled={page === totalPages}
        className={`flex h-9 cursor-pointer items-center gap-1 rounded-md border px-3 text-sm transition-colors ${
          page === totalPages
            ? 'cursor-not-allowed border-background-200 text-foreground-300'
            : 'border-background-200 text-foreground-700 hover:border-primary-300 hover:text-primary-700'
        }`}
      >
        下一页
        <i className="ri-arrow-right-s-line" />
      </button>
    </nav>
  );
}